import React from "react";
import { useAuth } from "../../context/AuthContext";

/**
 * CompanyCard
 *
 * Displays a company in the workspace selector.
 * Allows user to switch active company.
 */

export default function CompanyCard({ company }) {
  const { companyId, selectCompany } = useAuth();

  const isActive = companyId === company._id;

  const handleSelect = () => {
    if (!company?._id) return;
    selectCompany(company._id);
  };

  return (
    <button
      onClick={handleSelect}
      className={`w-full text-left rounded-xl border p-4 transition
      ${
        isActive
          ? "border-orange-500 bg-orange-50"
          : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
      }`}
    >
      <div className="flex items-center justify-between">
        {/* Company Name */}
        <div>
          <h3 className="text-sm font-semibold text-gray-900">
            {company?.name || "Unnamed Company"}
          </h3>

          {/* Plan */}
          <p className="text-xs text-gray-500 mt-1">
            Plan: {company?.plan || "free"}
          </p>
        </div>

        {/* Active Badge */}
        {isActive && (
          <span className="text-xs font-medium text-orange-600">
            Active
          </span>
        )}
      </div>
    </button>
  );
}